import { Input } from "Components/ui/input";
import { Label } from "Components/ui/label";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

function TextInput({
  label,
  placeholder,
  value,
  onChange,
  disabled,
  required,
  type,
  labelClassName,
  className,
}) {
  const [shownPass, setShownPass] = useState(false);
  if (type == "password")
    return (
      <div className="flex flex-col gap-2 relative w-full">
        <Label className="text-sm">{label}</Label>
        <Input
          className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-border py-5 rounded-lg focus:outline-none focus:border-primary focus:border bg-transparent"
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          disabled={disabled}
          required={required}
          type={shownPass ? "text" : "password"}
        />
        {shownPass ? (
          <EyeOff
            onClick={() => setShownPass(false)}
            className="absolute right-4 top-9 text-grey cursor-pointer"
          />
        ) : (
          <Eye
            onClick={() => setShownPass(true)}
            className="absolute right-4 top-9 text-grey cursor-pointer"
          />
        )}
      </div>
    );
  else
    return (
      <div className="flex flex-col gap-2 w-full items-start">
        <Label className={` text-sm ${labelClassName}`}>{label}</Label>
        <Input
          className={` [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-border py-5 rounded-lg focus:outline-none focus:border-primary focus:border ${className}`}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          disabled={disabled}
          required={required}
          type={type}
        />
      </div>
    );
}

export default TextInput;
